import React, { useRef, useState } from "react";
import { Card, Button } from "react-bootstrap";
import "./ResumeCard.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";

const ResumeCard = () => {
  const fileInputRef = useRef(null);

  const [resume, setResume] = useState(null);

  // Upload Resume
  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  // File Selected
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    setResume({
      file,
      name: file.name,
      url: URL.createObjectURL(file),
    });
  };

  // Delete Resume
  const handleDelete = () => {
    if (resume?.url) {
      URL.revokeObjectURL(resume.url);
    }

    setResume(null);
    fileInputRef.current.value = "";
  };

  return (
    <Card className="profile-card-pattern ResumeCard">
      <Card.Body className="profile-card-pattern__body">
        <div className="profile-card-pattern__header">
          <h3 className="profile-card-pattern__title">Resume</h3>
        </div>

        <div className="resume-attachment-box">
          <div className="resume-attachment-box__info">
            <div className="resume-attachment-box__icon">
              <FontAwesomeIcon icon={faFilePdf} />
            </div>

            {resume ? (
              <a
                href={resume.url}
                download={resume.name}
                className="resume-attachment-box__name"
              >
                {resume.name}
              </a>
            ) : (
              <span className="resume-attachment-box__name">
                No resume uploaded
              </span>
            )}
          </div>

          <div className="resume-attachment-box__actions">
            {resume && (
              <Button
                variant="link"
                className="resume-attachment-box__delete-btn"
                onClick={handleDelete}
              >
                🗑️
              </Button>
            )}

            <Button
              variant="link"
              className="resume-attachment-box__Replace-btn"
              onClick={handleUploadClick}
            >
              {resume ? "Replace Resume" : "Upload Resume"}
            </Button>

            <input
              type="file"
              ref={fileInputRef}
              accept=".pdf,.doc,.docx"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ResumeCard;